import { render } from "./CustomFieldSetup.vue?vue&type=template&id=4156755e&scoped=true"
import script from "./CustomFieldSetup.vue?vue&type=script&lang=js"
export * from "./CustomFieldSetup.vue?vue&type=script&lang=js"

import "./CustomFieldSetup.vue?vue&type=style&index=0&id=4156755e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4156755e"]])

export default __exports__